import Dropzone from './routing-dropzone'
import Filters from './routing-filters'
import Modal from './routing-modal'
import Packages from './routing-packages'
import Reservations from './routing-reservations'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Dropzone.state,
    Filters.state,
    Modal.state,
    Packages.state,
    Reservations.state
  ),
  mutations: Object.assign(
    Dropzone.mutations,
    Filters.mutations,
    Modal.mutations,
    Packages.mutations,
    Reservations.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/routing/index.js